module.exports = __webpack_public_path__ + "static/media/pruning_red.4277e8dc.svg";